import React, { createContext, useState } from "react";

export const AuthContext = createContext();

function AuthContextProvider(props) {
	const [token, setToken] = useState("");
	const [_id, set_Id] = useState("");

	function update_token(tkn) {
		setToken(tkn);
	}

	return (
		<AuthContext.Provider value={{ update_token, token, _id, set_Id }}>
			{props.children}
		</AuthContext.Provider>
	);
}

export default AuthContextProvider;
